import React, { Fragment, useEffect, useState } from "react";
import "../dashboard.css";
import { useNavigate } from "react-router-dom";
import { logoutdata } from "../../../services/login";
import PrivateRoute from "../privateroute";
export const AthleteHeader = () => {
  const navigate = useNavigate();
  const [dshow, setDShow] = useState(false);

  const [gshow, setGShow] = useState(false);

  const [loshow, setLOShow] = useState(false);

  function sidebaractive(head, hide) {
    setDShow(false);
    setGShow(false);
    setLOShow(false);

    if (head === "dashboard") {
      navigate("/dashboard");
      setDShow(hide);
    } else if (head === "gallery") {
      setGShow(hide);
      navigate("/gallery");
    } else if (head === "logout") {
      navigate("/login");
      setLOShow(hide);
    }
  }

  // function submenuactive(head, hide) {
  //   setCShow(false);
  //   setCInfo("");

  //   setPCShow(false);
  //   setADiet("");
  //   setADoping("");

  //   if (head === "coachinformation") {
  //     setCShow(hide);
  //     navigate("/athlete/coachinformation");
  //     setCInfo("active");
  //   } else if (head === "athletediet") {
  //     setPCShow(hide);
  //     navigate("/athlete/athletediet");
  //     setADiet("active");
  //   } else if (head === "antidoping") {
  //     setPCShow(hide);
  //     navigate("/athlete/antidoping");
  //     setADoping("active");
  //   }
  // }

  const [notclass, setNotClass] = useState("nav-item dropdown");
  function menunoti(name) {
    setProClass("");
    if (name === "nav-item dropdown iq-show") {
      setNotClass("nav-item dropdown");
    } else {
      setNotClass("nav-item dropdown iq-show");
    }
  }
  const [proclass, setProClass] = useState("");

  function profilenavshow(name) {
    setNotClass("nav-item dropdown");
    if (name === "iq-show") {
      setProClass("");
    } else {
      setProClass("iq-show");
    }
  }
  function Fullscreen() {
    setProClass("");
    setNotClass("nav-item dropdown");

    if (
      (document.fullScreenElement && document.fullScreenElement === null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const [resshow, setResShow] = useState(true);
  function topnavbar(hide) {
    setResShow(!hide);
  }

  const [sideshow, setSideShow] = useState(false);
  function opensidebar(hide) {
    setSideShow(!hide);
  }

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    sidebaractive(link[0], true);
    // submenuactive(link[1], true);
  }, []);

  function signout(){
    localStorage.clear();
    navigate("/login")
  }

  return (
    <Fragment>
      <PrivateRoute />
      <div className="header-top-bg">
        <div id="loading"></div>
        <div className="wrapper">
          <div className="iq-sidebar">
            <div className="iq-sidebar-logo d-flex justify-content-between">
              <a>
                <img
                  src={require("../../../assets/img/frameo.png")}
                  className="img-fluid"
                  alt=""
                />
              </a>
              <div className="iq-menu-bt align-self-center">
                <div className="wrapper">
                  <div className="line-menu half start"></div>
                  <div className="line-menu"></div>
                  <div className="line-menu half end"></div>
                </div>
              </div>
            </div>

            <div id="sidebar-scrollbar">
              <nav className="iq-sidebar-menu">
                <ul id="iq-sidebar-toggle" className="iq-menu">
                  {/* <li className="iq-menu-title">
                    <i className="ri-separator"></i>
                    <span>Main</span>
                  </li> */}
                  <li
                    className={dshow ? "active" : ""}
                    onClick={() => sidebaractive("dashboard", !dshow)}
                  >
                    <a className="iq-waves-effect">
                      <i className="las la-home"></i>
                      <span>Dashboard</span>
                    </a>
                  </li>

                  <li
                    className={gshow ? "active" : ""}
                    onClick={() => sidebaractive("gallery", !gshow)}
                  >
                    <a className="iq-waves-effect">
                      <i className="las la-user"></i>
                      <span>Gallery</span>
                    </a>
                  </li>

                  {/* <li className={cshow ? "active" : ""}>
                    {cshow && (
                      <a
                        className="iq-waves-effect"
                        onClick={() => sidebaractive("coaches", false)}
                      >
                        <i className="las la-users"></i>
                        <span>Coach Details</span>
                        <i className="ri-arrow-right-s-line iq-arrow-right"></i>
                      </a>
                    )}
                    {!cshow && (
                      <a
                        className="iq-waves-effect collapsed"
                        onClick={() => sidebaractive("coaches", true)}
                      >
                        <i className="las la-users"></i>
                        <span>Coach Details</span>
                        <i className="ri-arrow-right-s-line iq-arrow-right"></i>
                      </a>
                    )}
                    <ul
                      className={
                        cshow
                          ? "iq-submenu collapsed show"
                          : "iq-submenu collapse"
                      }
                    >
                      <li
                        className={cinfo}
                        onClick={() => submenuactive("coachinformation", true)}
                      >
                        <a>Coach Information</a>
                      </li>
                    </ul>
                  </li> */}

                  
                  <li
                    className={loshow ? "active" : ""}
                    onClick={() => sidebaractive("logout", !loshow)}
                  >
                    <a className="iq-waves-effect" onClick={signout}>
                      <i className="las la-sign-out-alt"></i>
                      <span>Logout</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="p-3"></div>
            </div>
          </div>

          <div className="iq-top-navbar">
            <div className="iq-navbar-custom">
              <div className="iq-sidebar-logo">
                <div className="top-logo">
                  <a className="logo">
                    <img
                      src={require("../../../assets/img/frameo.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </a>
                </div>
              </div>
              <nav className="navbar navbar-expand-lg navbar-light p-0">
              <h4 className="pl-5">Welcome to Frameo</h4>

                <button
                  className={
                    resshow ? "navbar-toggler collapsed" : "navbar-toggler"
                  }
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  onClick={() => topnavbar(resshow)}
                >
                  <i className="ri-menu-3-line"></i>
                </button>
                <div
                  className="iq-menu-bt align-self-center"
                  onClick={() => opensidebar(sideshow)}
                >
                  <div
                    className={sideshow ? "wrapper-menu open" : "wrapper-menu"}
                  >
                    <div className="line-menu half start"></div>
                    <div className="line-menu"></div>
                    <div className="line-menu half end"></div>
                  </div>
                </div>
                <div
                  className={
                    resshow
                      ? "navbar-collapse collapse"
                      : "navbar-collapse collapse show"
                  }
                  id="navbarSupportedContent"
                >

                  <ul className="navbar-nav ml-auto navbar-list">
                   
                    <li
                      className="nav-item iq-full-screen"
                      onClick={Fullscreen}
                    >
                      <a className="iq-waves-effect" id="btnFullscreen">
                        <i className="ri-fullscreen-line"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                
              </nav>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
